import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ScrollStatus } from 'smooth-scrollbar/interfaces';
import { Pagination } from 'src/app/classes/pagination';
import { LANG } from 'src/app/models/enums/lang.enum';
import { LocalStorageEnum } from 'src/app/models/enums/local-storage.enum';
import { RESPONSE_STATUS } from 'src/app/models/enums/response-status.enum';
import { STATUS } from 'src/app/models/enums/status.enum';
import { User } from 'src/app/models/user';
import { DepartmentService } from 'src/app/services/department.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { UserAdminService } from 'src/app/services/user-admin.service';

@Component({
  selector: 'app-assign-dialog',
  templateUrl: './assign-dialog.component.html',
  styleUrls: ['./assign-dialog.component.scss'],
})
export class AssignDialogComponent implements OnInit, OnDestroy {
  status: string = '';
  lang: LANG;
  user: User | any;
  license: any = null;
  formDataGroup: UntypedFormGroup;
  departments: any[] = [];
  users: Array<User> = [];
  documents: Array<any> = [];
  // selectedDepartment: any = null;
  // selectedUser: any = null;
  con_id: string;
  type: string;

  title: string = '-';

  readonly LANG = LANG;

  private _destroyed = new Subject<void>();

  getDepartmentQueue: boolean = false;
  departmentPage: Pagination = { page: 1, count: 10, total: 1 };

  constructor(
    private formBuilder: UntypedFormBuilder,
    private translate: TranslateService,
    private departmentService: DepartmentService,
    private userService: UserAdminService,
    private localStorageService: LocalStorageService,
    private dialogRef: MatDialogRef<AssignDialogComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.con_id = data?.ref_id;
    this.type = data?.type;

    // this.documents = data?.license?.documents ? data.license.documents : null;
    // this.license = data?.license;
    this.formDataGroup = this.formBuilder.group({
      to_department: ['', Validators.required],
      to_user: ['', data?.required ? Validators.required : []],
      description: ['', null],
    });

    this.translate.onLangChange
      .pipe(takeUntil(this._destroyed))
      .subscribe((event: LangChangeEvent) => {
        this.lang = event.lang as LANG;
      });
    this.lang = this.translate.currentLang as LANG;
    this.user = JSON.parse(
      this.localStorageService.decryptSpecialCharacter(LocalStorageEnum.user) ||
        '',
    );

    this.title = 'button.allocate';
    if (data.title) {
      this.title = data.title;
    }
  }

  ngOnInit(): void {
    this.getAllDepartment();
  }

  onSubmit() {
    const value = this.formDataGroup.value;
    let department = value.to_department;
    let body = {
      ref_id: this.con_id,
      description: value.description,
      to_department: department ? department : this.user.department,
      to_user: value.to_user,
      type: this.type,
    };

    if (this.status == '') {
      if (department && value.to_user) {
        this.status = STATUS.ASSIGN;
      } else {
        this.status = STATUS.ALLOCATE;
      }
    }

    this.dialogRef.close({
      status: this.status,
      body: body,
    });
  }

  onDepartmentListScroll(scroll: ScrollStatus) {
    const percent = (scroll.offset.y / scroll.limit.y) * 100;

    if (
      percent >= 100 &&
      !this.getDepartmentQueue &&
      this.departments.length < this.departmentPage.total
    ) {
      this.departmentPage.page++;
      this.getAllDepartment();
    }
  }

  onDepartmentSelectChange(departmentID: string) {
    this.getUserByDepartment(departmentID);
  }

  getUserByDepartment(departmentID: string, search?: string) {
    this.userService
      .getUserByDepartment(departmentID, 1, 100, search)
      .subscribe((res) => {
        this.users = res.data;
      });
  }

  onUserSearch(search: string) {
    const departmentID = this.formDataGroup.get('to_department')?.value;
    if (departmentID) {
      this.getUserByDepartment(departmentID, search);
    }
  }

  getAllDepartment(query?: any) {
    this.getDepartmentQueue = true;
    this.departmentService
      .getAllDepartment(
        this.departmentPage.page,
        this.departmentPage.count,
        query,
      )
      .subscribe((res) => {
        if (res.status != RESPONSE_STATUS.SUCCESS) {
          this.getDepartmentQueue = false;
          return;
        }

        if (this.departmentPage.page === 1) {
          this.departments = res.data?.departments || [];
        } else {
          this.departments = [
            ...this.departments,
            ...(res.data?.departments || []),
          ];
        }

        this.departmentPage = res.data.pagination;
        this.getDepartmentQueue = false;

        this.cdr.detectChanges();
      });
  }

  onDepartmentSearchChange(search: any) {
    this.departmentPage.page = 1;
    this.getAllDepartment(search);
  }

  resetSelectedUser() {
    this.formDataGroup.controls['to_user'].setValue(null);
  }

  /**
   *
   * @param user
   * @returns
   */
  getUserName(user: any) {
    if (!user) return '';

    if (user.first_name_kh || user.last_name_kh) {
      if (this.lang != 'en')
        return user.last_name_kh + ' ' + user.first_name_kh;
      else return user.last_name_en + ' ' + user.first_name_en;
    } else if (user.first_name_en || user.last_name_en) {
      return user.last_name_en + ' ' + user.first_name_en;
    } else {
      return user.last_name + ' ' + user.first_name;
    }
  }

  ngOnDestroy(): void {
    this._destroyed.next();
    this._destroyed.complete();
  }
}
